/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCreditCardSlash: {
  name: 'credit-card-slash';
  data: string;
} = {
  name: 'credit-card-slash',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.707 3.293a1 1 0 0 0-1.414 1.414L7.586 9H4V7.5a1 1 0 0 0-2 0V18a2 2 0 0 0 2 2h11a1 1 0 1 0 0-2H4v-7h5.586l9.707 9.707a1 1 0 0 0 1.414-1.414L12.414 11H20v5a1 1 0 1 0 2 0V6a2 2 0 0 0-2-2H9a1 1 0 0 0 0 2h11v3h-9.586L4.707 3.293ZM6 15a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
